import { render } from "./CatalogRibbon.vue?vue&type=template&id=44706eda&scoped=true"
import script from "./CatalogRibbon.vue?vue&type=script&lang=js"
export * from "./CatalogRibbon.vue?vue&type=script&lang=js"

import "./CatalogRibbon.vue?vue&type=style&index=0&id=44706eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44706eda"]])

export default __exports__